import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onetrip-page__filter" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "onetrip-page__filter__separator" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_btn_left_filter = _resolveComponent("btn-left-filter")
  const _component_side_bar_tikets = _resolveComponent("side-bar-tikets")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_btn_left_filter, {
      setActive: _ctx.setActive,
      filterData: _ctx.filterData,
      isActive: _ctx.isActive,
      orderType: _ctx.orderTypes.AVIA,
      title: "Авиабилеты",
      type: "avia"
    }, null, 8, ["setActive", "filterData", "isActive", "orderType"]),
    _createVNode(_component_btn_left_filter, {
      filterData: _ctx.filterData,
      isActive: _ctx.isActive,
      orderType: _ctx.orderTypes.RAILWAY,
      setActive: _ctx.setActive,
      title: "Ж/Д билеты",
      type: "rail"
    }, null, 8, ["filterData", "isActive", "orderType", "setActive"]),
    _createVNode(_component_btn_left_filter, {
      filterData: _ctx.filterData,
      isActive: _ctx.isActive,
      orderType: _ctx.orderTypes.HOTEL,
      setActive: _ctx.setActive,
      title: "Бронирование отелей",
      type: "hotel"
    }, null, 8, ["filterData", "isActive", "orderType", "setActive"]),
    _createVNode(_component_btn_left_filter, {
      filterData: _ctx.filterData,
      isActive: _ctx.isActive,
      orderType: _ctx.orderTypes.TRANSFER,
      setActive: _ctx.setActive,
      title: "Трансфер",
      type: "transfer"
    }, null, 8, ["filterData", "isActive", "orderType", "setActive"]),
    _createVNode(_component_btn_left_filter, {
      filterData: _ctx.filterData,
      isActive: _ctx.isActive,
      orderType: _ctx.orderTypes.FREE,
      setActive: _ctx.setActive,
      title: "Свободная услуга",
      type: "freeService"
    }, null, 8, ["filterData", "isActive", "orderType", "setActive"]),
    _hoisted_2,
    _createVNode(_component_side_bar_tikets)
  ]))
}